import { configureStore } from "@reduxjs/toolkit";
import { coursesReducer } from "./collections";

export const store = configureStore({
    reducer: {
        courses: coursesReducer,
    },
    // middleware: (gdm) => gdm().concat(/* custom */),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
